module.exports = __webpack_public_path__ + "static/media/news.439ad957.png";